let clicks = 0;
let prev = '';
const refreshCache = {};

async function refreshRight(url) {
    if (prev === url) return;
    prev = url;
    clicks += 1;
    if (clicks === 4) {
        document.location.href = url;
        return;
    }
    const [specialContainer, buyButton] = [
        document.getElementById('specials'),
        document.getElementById('blocks')
    ];

    if (!specialContainer || !buyButton) return;

    if (refreshCache[url]) {
        buyButton.innerHTML = refreshCache[url][0];
        specialContainer.innerHTML = refreshCache[url][1];

        return;
    }

    const specialUrl = `${url}&section_id=product-blocks`;
    const buyButtonsUrl = `${url}&section_id=buy-buttons`;

    try {
        const [buyResponse, specialResponse] = await Promise.all([
            fetch(buyButtonsUrl),
            fetch(specialUrl)
        ]);

        if (buyResponse.ok) {
            buyButton.innerHTML = await buyResponse.text();
        }

        if (specialResponse.ok) {
            specialContainer.innerHTML = await specialResponse.text();
        }

        window.dispatchEvent(new CustomEvent('pdp_variant_change'));

        refreshCache[url] = [
            buyButton.innerHTML,
            specialContainer.innerHTML
        ];

    } catch (error) {
        console.error('Fehler beim Laden der Inhalte:', error);
    }
}

function jsonToFormData(json) {
    const fd = new FormData();

    for (const key in json) {
        const value = json[key];

        if (Array.isArray(value)) {
            value.forEach(v => fd.append(key, v));
        } else {
            fd.append(key, value);
        }
    }

    return fd;
}

window.addEventListener("message", (event) => {
    if (event.data.type === "purelei:command") {
        if (event.data.id === "modal:close")
            document.getElementById('in9iteL3F2EdR8NPy').setAttribute("data-state", "closed");
        if (event.data.id === "cart:add") {
            const formData = jsonToFormData(event.data.data);
            window.PURELEI.Cart.commitFormData(formData)
        }
    }
});
